import { ENG, CH } from "../../constants"

let dictionary = {}

dictionary[ENG] = {
    HOME: "HOME",
    INTRO: "Introduction",
    EDUCATION: "Education",
    EXPERIENCE: "Experience",
    SKILL: "Skill",
    CONTACT: "Contact"
}

dictionary[CH] = {
    HOME: "首頁",
    INTRO: "個人簡介",
    EDUCATION: "學習歷程",
    EXPERIENCE: "相關經歷",
    SKILL: "專業技能",
    CONTACT: "聯絡方式"
}

export default dictionary
